import { render, staticRenderFns } from "./FormaRecebimento.vue?vue&type=template&id=a77f0be2&scoped=true"
import script from "./FormaRecebimento.vue?vue&type=script&lang=js"
export * from "./FormaRecebimento.vue?vue&type=script&lang=js"
import style0 from "./FormaRecebimento.vue?vue&type=style&index=0&id=a77f0be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77f0be2",
  null
  
)

export default component.exports